<template>
  <!-- 新建提货指令 -->
  <div class="contentBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="submit"
        >保存</el-button
      >
      <!-- <el-button style="margin-top: 10px" class="glo_bg" @click="saveConfirm('baseInFormRef')">取消</el-button> -->
      <span v-if="isSee == 'isSee'">
        <el-button style="margin-top: 10px" class="glo_bg" @click="saveClick(1)"
          >新增</el-button
        >
        <el-button style="margin-top: 10px" class="glo_bg" @click="saveClick(2)"
          >修改</el-button
        >
        <el-button style="margin-top: 10px" class="glo_bg" @click="saveClick(3)"
          >复制新增</el-button
        >
      </span>
    </div>
    <!-- 基本信息 -->
    <div class="infoDiv">
      <div class="h3title">基本信息</div>
      <div class="formbox">
        <el-form label-width="100px" class="glo_formBox">
          <el-form-item label="指令编号:" required>
            <el-input
              :disabled="disabledSee"
              v-model="commandReq.commandNumber"
              placeholder="不录入则自动生成"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="开单客户:" required>
            <el-select
              :disabled="disabledSee"
              clearable
              filterable
              remote
              allow-create
              :remote-method="remoteMethodCustomer"
              default-first-option
              v-model="commandReq.customerName"
              placeholder="请选择"
              @change="changeMethodCustomer"
              @focus="focusMethodCustomer"
            >
              <el-option
                v-for="(item, index) in CustomerLists"
                :key="index"
                :label="item.customerName"
                :value="item.customerName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="运单号:">
            <el-input
              :disabled="disabledSee"
              v-model="commandReq.waybillNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="客户单号:">
            <el-input
              :disabled="disabledSee"
              v-model="commandReq.customerOrderNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="开单接收人:">
            <el-select
              :disabled="disabledSee"
              v-model="commandReq.waybillRecipientId"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod(e, 'employee', 'employeeList');
                }
              "
              @change="
                (e) => {
                  changeMethod(e, 'employeeList', 'waybillRecipient');
                }
              "
              @focus="focusMethod('employee', 'employeeList')"
              @clear="remoteMethod('', 'employee', 'employeeList')"
            >
              <el-option
                v-for="(item, index) in employeeList"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="调度接收人:">
            <el-select
              :disabled="disabledSee"
              v-model="commandReq.dispatchRecipientId"
              placeholder="请选择"
              clearable
              remote
              filterable
              :remote-method="
                (e) => {
                  remoteMethod(e, 'employee', 'employeeList_1');
                }
              "
              @change="
                (e) => {
                  changeMethod(e, 'employeeList_1', 'dispatchRecipient');
                }
              "
              @focus="focusMethod('employee', 'employeeList_1')"
              @clear="remoteMethod('', 'employee', 'employeeList_1')"
            >
              <el-option
                v-for="(item, index) in employeeList_1"
                :key="index"
                :label="item.name"
                :value="item.documentId"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <!-- 发货信息 -->
      <div class="infoDiv">
        <div class="h3title">发货信息</div>
        <div class="formbox">
          <el-form label-width="100px" class="glo_formBox">
            <el-form-item label="发货人:" required>
              <el-input
                :disabled="disabledSee"
                v-model="takeAddrReqs.contacts"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="发货电话:" required>
              <el-input
                :disabled="disabledSee"
                v-model="takeAddrReqs.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="发货单位:">
              <el-input
                :disabled="disabledSee"
                v-model="takeAddrReqs.company"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-button
              :disabled="disabledSee"
              class="glo_bgcMainColor formBtns"
              @click="changeRecAddress(1)"
              >选择发货地址</el-button
            >
            <div class="checkBox">
              <el-checkbox :disabled="disabledSee" v-model="isAutoAddr_sj"
                >自动收录发货地址</el-checkbox
              >
            </div>
            <el-form-item
              style="width: 100%; border: 0"
              required
              label="发货地址:"
            >
              <div class="disFlexs">
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="takeAddrReqs.provinceName"
                  placeholder="请选择省"
                  clearable
                  filterable
                  @change="changeProvince"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="takeAddrReqs.cityName"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @change="changeCity"
                  @focus="getCityName(takeAddrReqs.provinceName)"
                >
                  <el-option
                    v-for="(item, index) in cityNameList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="takeAddrReqs.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName(takeAddrReqs.cityName)"
                >
                  <el-option
                    v-for="(item, index) in areaNameList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  :disabled="disabledSee"
                  class="selectAddress addressDetails"
                  v-model="takeAddrReqs.address"
                  placeholder="请输入详细地址"
                  clearable
                  @keyup.enter.native="geocode(takeAddrReqs.address)"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="infoDiv">
        <!-- 提货规划 -->
        <div class="h3title">收货信息</div>
        <div class="formbox">
          <el-form label-width="100px" class="glo_formBox">
            <el-form-item label="提货计划:" style="min-width: 320px" required>
              <el-radio-group
                :disabled="disabledSee"
                v-model="transportPlanReq.transportPlan"
              >
                <el-radio label="ru_cang:transport_plan">入仓</el-radio>
                <el-radio label="zhi_song:transport_plan">直送</el-radio>
                <el-radio label="wai_fa:transport_plan">外发</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="提货时间:" required>
              <el-date-picker
                :disabled="disabledSee"
                v-model="transportPlanReq.takeTime"
                value-format="yyyy-MM-dd  HH:mm:ss"
                type="datetime"
                placeholder="请选择"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="车型:" required>
              <el-select
                :disabled="disabledSee"
                filterable
                clearable
                v-model="transportPlanReq.carTypeConfDictId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in car_type_list"
                  :key="item.confDictId"
                  :label="item.key"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div id="tiHuoForm">
          <el-form
            v-if="transportPlanReq.transportPlan == 'ru_cang:transport_plan'"
            label-width="100px"
            class="glo_formBox"
          >
            <el-form-item label="入仓仓库:" required>
              <el-select
                :disabled="disabledSee"
                v-model="rukuPlanReq.intoDeptId"
                placeholder="请选择"
                clearable
                remote
                filterable
                :remote-method="
                  (e) => {
                    remoteMethod(e, 'storage', 'storageList');
                  }
                "
                @change="
                  (e) => {
                    changeMethod(e, 'storageList', 'intoDeptName');
                  }
                "
                @focus="focusMethod('storage', 'storageList')"
                @clear="remoteMethod('', 'storage', 'storageList')"
              >
                <el-option
                  v-for="(item, index) in storageList"
                  :key="index"
                  :label="item.name"
                  :value="item.documentId"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <el-form
            v-if="transportPlanReq.transportPlan == 'zhi_song:transport_plan'"
            label-width="100px"
            class="glo_formBox"
          >
            <el-form-item label="收货人:" required>
              <el-input
                :disabled="disabledSee"
                v-model="zhiSongPlanReq.contacts"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="收货电话:" required>
              <el-input
                :disabled="disabledSee"
                v-model="zhiSongPlanReq.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="收货单位:" required>
              <el-input
                :disabled="disabledSee"
                v-model="zhiSongPlanReq.company"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
            <el-button
              :disabled="disabledSee"
              class="glo_bgcMainColor formBtns"
              @click="changeRecAddress(2)"
              >选择收货地址</el-button
            >
            <div class="checkBox">
              <el-checkbox :disabled="disabledSee" v-model="isAutoAddr_sj_1"
                >自动收录收货地址</el-checkbox
              >
            </div>
            <el-form-item
              style="width: 100%; border: 0"
              label="收货地址:"
              required
            >
              <div class="disFlexs">
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="zhiSongPlanReq.provinceName"
                  placeholder="请选择省"
                  clearable
                  filterable
                  @change="changeProvince_1"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="zhiSongPlanReq.cityName"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @change="changeCity_1"
                  @focus="getCityName_1(zhiSongPlanReq.provinceName)"
                >
                  <el-option
                    v-for="(item, index) in cityNameList_1"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee"
                  class="selectAddress"
                  v-model="zhiSongPlanReq.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName_1(zhiSongPlanReq.cityName)"
                >
                  <el-option
                    v-for="(item, index) in areaNameList_1"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  :disabled="disabledSee"
                  class="selectAddress addressDetails"
                  v-model="zhiSongPlanReq.address"
                  placeholder="请输入详细地址"
                  clearable
                  @keyup.enter.native="geocode_1(zhiSongPlanReq.address)"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
          <!-- 外发 -->
          <el-form
            v-if="transportPlanReq.transportPlan == 'wai_fa:transport_plan'"
            :model="transportPlanReq"
            ref="baseInFormRef"
            label-width="100px"
            class="glo_formBox"
          >
            <el-form-item label="外发承运商:" required>
              <el-select
                :disabled="disabledSee"
                v-model="waiFaPlanReq.carrierId"
                placeholder="请选择"
                clearable
                remote
                filterable
                :remote-method="
                  (e) => {
                    remoteMethodCarrier(e);
                  }
                "
                @change="
                  (e) => {
                    changeMethodCarrier(e);
                  }
                "
                @focus="focusMethodCarrier"
                @clear="remoteMethodCarrier('')"
              >
                <el-option
                  v-for="(item, index) in changeCarrierList"
                  :key="index"
                  :label="item.carrierName"
                  :value="item.carrierId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="网点:" required>
              <el-select
                :disabled="disabledSee"
                v-model="waiFaPlanReq.carrierDeptId"
                placeholder="请选择"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in CarrierDeptListList"
                  :key="index"
                  :label="item.deptName"
                  :value="item.carrierDeptId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提货方式:" required>
              <el-select
                :disabled="disabledSee"
                filterable
                clearable
                v-model="waiFaPlanReq.outgoingReceiveMethodConfDictId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in OUTTakeMethodList"
                  :key="item.confDictId"
                  :label="item.key"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="送货方式:" required>
              <el-select
                :disabled="disabledSee"
                filterable
                clearable
                v-model="waiFaPlanReq.outgoingSendMethodConfDictId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in OUTsendMethodList"
                  :key="item.confDictId"
                  :label="item.key"
                  :value="item.confDictId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="infoDiv">
      <div class="formbox">
        <el-form label-width="100px" class="glo_formBox">
          <el-form-item class="textArea" style="width: 100%" label="注意事项:">
            <el-input
              :disabled="disabledSee"
              placeholder="请输入"
              clearable
              v-model="commandReq.remarks"
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 货物信息 -->
    <div class="infoDiv" id="tables">
      <div class="h3title">货物信息</div>
      <div class="formbox goodsItmes">
        <div class="glo_Table goodsTable">
          <el-table
            :data="itemReqs"
            border
            style="width: 1400px"
            show-summary
            ref="mytable1"
            :summary-method="getSummaries"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column prop="goodsNumber" label="货物编号">
              <template slot-scope="scope">
                <el-input
                  @input="onInputHW(scope.$index)"
                  :disabled="disabledSee"
                  type="text"
                  v-model="itemReqs[scope.$index].goodsNumber"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="goodsName"
              label="*货物名称"
            >
              <template slot-scope="scope">
                <el-input
                  @input="onInputHW(scope.$index)"
                  :disabled="disabledSee"
                  type="text"
                  v-model="itemReqs[scope.$index].goodsName"
                  placeholder="请输入"
                  filterable
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="itemCategoryName"
              label="品类"
            >
              <template slot-scope="scope">
                <el-select
                  :disabled="disabledSee"
                  clearable
                  filterable
                  remote
                  allow-create
                  default-first-option
                  placeholder="请选择"
                  v-model="itemReqs[scope.$index].itemCategoryName"
                  :remote-method="
                    (e) => {
                      remoteMethodCategory(e, scope.$index);
                    }
                  "
                  @change="
                    (e) => {
                      changeMethodCategory(e, scope.$index);
                    }
                  "
                  @focus="focusMethodCategory(scope.$index)"
                  @clear="remoteMethodCategory('', scope.$index)"
                >
                  <el-option
                    v-for="(item2, index2c) in itemReqs[scope.$index]
                      .CategoryList"
                    :key="index2c"
                    :label="item2.itemCategoryName"
                    :value="item2.itemCategoryName"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="packageName" label="包装">
              <template slot-scope="scope">
                <el-select
                  @change="onInputHW(scope.$index)"
                  :disabled="disabledSee"
                  v-model="itemReqs[scope.$index].packageName"
                  filterable
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item2, index2c) in packageNameList"
                    :key="index2c"
                    :label="item2.val"
                    :value="item2.val"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="packageCout" label="*件数" sortable>
              <template slot-scope="scope">
                <el-input
                  @input="onInputHW(scope.$index)"
                  :disabled="disabledSee"
                  type="number"
                  v-model="itemReqs[scope.$index].packageCout"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="grossWeight" label="*毛重" sortable>
              <template slot-scope="scope">
                <el-input
                  @input="onInputHW(scope.$index)"
                  :disabled="disabledSee"
                  type="number"
                  v-model="itemReqs[scope.$index].grossWeight"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="netWeight" label="净重" sortable>
              <template slot-scope="scope">
                <el-input
                  @input="onInputHW(scope.$index)"
                  :disabled="disabledSee"
                  type="number"
                  v-model="itemReqs[scope.$index].netWeight"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="volume"
              label="*体积/m³"
              sortable
              width="100"
            >
              <template slot-scope="scope">
                <el-input
                  @input="onInputHW(scope.$index)"
                  :disabled="disabledSee"
                  type="number"
                  v-model="itemReqs[scope.$index].volume"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="volumeWeight"
              label="体积重量/KG"
              sortable
              width="120"
            >
              <template slot-scope="scope">
                <el-input
                  @input="onInputHW(scope.$index)"
                  :disabled="disabledSee"
                  type="number"
                  v-model="itemReqs[scope.$index].volumeWeight"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="weightVolume"
              label="重量体积/m³"
              sortable
              width="120"
            >
              <template slot-scope="scope">
                <el-input
                  @input="onInputHW(scope.$index)"
                  :disabled="disabledSee"
                  type="number"
                  v-model="itemReqs[scope.$index].weightVolume"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="billingWeight"
              label="计费取值"
              sortable
              width="120"
            >
              <template slot-scope="scope">
                <el-input
                  @input="onInputHW(scope.$index)"
                  :disabled="disabledSee"
                  type="number"
                  v-model="itemReqs[scope.$index].billingWeight"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="specs" label="规格尺寸" v-if="!disabledSee">
              <template slot-scope="scope">
                <div class="linkTabel" @click="clickSet(scope.$index)">
                  尺寸设置
                </div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" v-if="!disabledSee">
              <template slot-scope="scope">
                <div class="iconList">
                  <i
                    v-if="scope.$index == 0"
                    class="el-icon-circle-plus iconSize"
                    @click="AddGoods(scope.$index)"
                  ></i>
                  <el-popconfirm
                    v-else
                    title="确定删除该行货物信息吗"
                    @confirm="delGoods(scope.$index)"
                  >
                    <i slot="reference" class="el-icon-remove iconSize"></i>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <myDialog
      :diaWidth="diaWidth1"
      :dialogTitle="dialogTitle1"
      :isShowDialog="isShowDialog1"
      :showCacel="false"
      @handleCloseDia="handleCloseDia1"
      @diaCancelBtn="handleCloseDia1"
      @diaConfirmBtn="diaConfirmBtn1"
    >
      <div class="glo_dialogForm">
        <el-table :data="specifications" border style="width: 100%">
          <el-table-column label="*长" prop="length">
            <template slot-scope="scope">
              <el-input
                v-model="specifications[scope.$index].length"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*宽" prop="wide">
            <template slot-scope="scope">
              <el-input
                v-model="specifications[scope.$index].wide"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*高" prop="height">
            <template slot-scope="scope">
              <el-input
                v-model="specifications[scope.$index].height"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*件数" prop="packageCout">
            <template slot-scope="scope">
              <el-input
                v-model="specifications[scope.$index].packageCout"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <div class="iconList">
                <i
                  v-if="specifications.length == scope.$index + 1"
                  class="el-icon-circle-plus iconSize"
                  @click="clickAdd"
                ></i>
                <el-popconfirm
                  v-if="specifications.length > 1"
                  title="确定删除该行规格吗"
                  @confirm="clickDel(scope.$index)"
                >
                  <i slot="reference" class="el-icon-remove iconSize"></i>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </myDialog>
    <!-- 弹窗 收件人地址 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      :showConfirm="false"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3"
    >
      <div class="glo_dialogForm" ref="myDialogRef_as">
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form
            v-if="isShowDialog3"
            :model="queryData"
            class="glo_form"
            label-position="left"
          >
            <el-form-item class="queryItems" label="单位/仓库:">
              <el-input
                clearable
                v-model="queryData.deptName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="联系人:">
              <el-input
                clearable
                v-model="queryData.personnelName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="getCustomerAddrList"
              >查询</el-button
            >
          </el-form>
        </div>
        <div class="glo_Table">
          <el-table
            :height="TBHeight_as"
            header-align="center"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            border
            stripe
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in addressTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
            <el-table-column fixed="right" label="操作" min-width="100px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button
                    class="rbtns"
                    @click.stop="changeAddress(scope.row)"
                    >选择</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <paging
          :pageNum="pageStart_as"
          :total="pageCount_as"
          :size="pageTotal_as"
          @handleSizeChange="handleSizeChange_as"
          @handleCurrentChange="handleCurrentChange_as"
        ></paging>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import _ from "lodash";
import { constants } from "os";
import paging from "@/components/pagings.vue"; //分页组件
export default {
  inject: ["reload"],
  components: {
    myDialog,
    paging,
  },
  data() {
    return {
      pageStart_as: 1, //  页码
      pageCount_as: 0, //  总条数
      pageTotal_as: this.$COMMON.pageTotals, //
      TBHeight_as: 500,
      // params: {
      //   commandReq: {},
      //   transportPlanReq: {},
      //   takeAddrReqs: [
      //     {
      //       itemReqs: [],
      //     },
      //   ],
      // },
      isSee: "",
      saveKeys: "",
      disabledSee: false,
      commandId: "",
      commandReq: {
        //	基础信息
        commandNumber: "",
        customerId: "",
        customerName: "",
        customerOrderNumber: "",
        dispatchRecipient: "",
        dispatchRecipientId: "",
        remarks: "",
        waybillNumber: "",
        waybillRecipient: "",
        waybillRecipientId: "",
      },
      takeAddrReqs: {
        address: "",
        areaName: "",
        cityName: "",
        company: "",
        contacts: "",
        provinceName: "",
        phone: "",
        // tel: "",
      },
      itemReqs: [
        {
          billingWeight: "",
          goodsName: "",
          goodsNumber: "",
          grossWeight: "",
          itemCategoryCode: "",
          itemCategoryName: "",
          itemSpecsReqs: [
            {
              height: "",
              length: "",
              packageCout: "",
              wide: "",
            },
          ],
          netWeight: "",
          packageCout: "",
          packageName: "",
          serialNumber: "",
          specs: "",
          volume: "",
          volumeWeight: "",
          weightVolume: "",
          CategoryList: [],
        },
      ],
      transportPlanReq: {
        carType: "",
        carTypeConfDictId: "",
        takeTime: "",
        transportPlan: "ru_cang:transport_plan",
        // rukuPlanReq: {},
        // waiFaPlanReq: {},
        // zhiSongPlanReq: {},
      },
      rukuPlanReq: {
        intoDeptId: "",
        intoDeptName: "",
      },
      waiFaPlanReq: {
        carrierDeptId: "",
        carrierDeptName: "",
        carrierId: "",
        carrierName: "",
        outgoingReceiveMethod: "",
        outgoingReceiveMethodConfDictId: "",
        outgoingSendMethod: "",
        outgoingSendMethodConfDictId: "",
      },
      zhiSongPlanReq: {
        address: "",
        areaName: "",
        cityName: "",
        company: "",
        contacts: "",
        provinceName: "",
        phone: "",
        // tel: "",
      },

      isAutoAddr_sj: true,
      SuperiorRegionList: [], //省
      cityNameList: [], //市
      areaNameList: [], //区
      isAutoAddr_sj_1: true,
      cityNameList_1: [], //市
      areaNameList_1: [], //区

      CustomerLists: [], //客户列表
      addressNaemList: [], //客户档案列表
      OUTsendMethodList: [], //送货方式
      OUTTakeMethodList: [], //外发提货
      packageNameList: [], //货物信息
      car_type_list: [], //车型
      employeeList: [], // 开单接收人
      employeeList_1: [], //调度接收人
      storageList: [], //入仓仓库
      CarrierDeptListList: [], //网点
      changeCarrierList: [], //外发承运商

      // 地址弹窗
      isShowDialog3: false,
      dialogTitle3: "",
      diaWidth3: "80%",
      tableData: [],
      addressTableHeard: [
        {
          name: "单位/仓库",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系人",
          field: "personnelName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "所属网点",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "省份",
          field: "provinceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "城市",
          field: "cityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "区县",
          field: "areaName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "详细地址",
          field: "address",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData: [], //收发地址 表格选择
      queryData: {
        //收发地址 查询条件
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      },

      //弹框 规格尺寸
      specIndex1: 0,
      isShowDialog1: false,
      dialogTitle1: "规格尺寸",
      diaWidth1: "60%",
      specifications: [
        {
          height: "",
          length: "",
          packageCout: "",
          wide: "",
        },
      ], //规格尺寸 数据
      totalArr: [
        "packageCout",
        "grossWeight",
        "netWeight",
        "volume",
        "volumeWeight",
        "weightVolume",
        "billingWeight",
      ], //  表格需要合计的字段
    };
  },
  // computed: {
  //   ""() {
  //     return "";
  //   },
  // },
  watch: {},
  created() {},
  mounted() {
    // 根据字典类型获取字典值下拉列表
    this.getConfDictValDownList("car_type"); //车型
    this.getConfDictValDownList("package_name"); //获取包装
    this.getConfDictValDownList("out_going_take_method"); //提货方式
    this.getConfDictValDownList("out_going_send_method"); //送货方式
    this.getParentName("中华人民共和国"); //默认查到各省
    this.focusMethod("employee", "employeeList");
    this.focusMethod("employee", "employeeList_1");
    // //  动态查询返回字段
    // this.$COMAPI.getReportFiledsAPi("command_detail");
    // this.$COMAPI.getReportFiledsAPi("command_item_list");
    // this.$COMAPI.getReportFiledsAPi("command_item_specs_list");
  },
  activated() {
    let pageType = this.$route.query.pageType || ""; //isTabs==tab切换的页面,不刷新页面
    let isreloads = this.$route.query.isreload; //关闭页面的标记,关闭tab,不刷新页面
    if (pageType == "isTabs" || isreloads == "isreload") {
      return false;
    }else {
      
    }

    this.commandId = "";
    this.commandReq = {
      //	基础信息
      commandNumber: "",
      customerId: "",
      customerName: "",
      customerOrderNumber: "",
      dispatchRecipient: "",
      dispatchRecipientId: "",
      remarks: "",
      waybillNumber: "",
      waybillRecipient: "",
      waybillRecipientId: "",
    };
    this.takeAddrReqs = {
      address: "",
      areaName: "",
      cityName: "",
      company: "",
      contacts: "",
      provinceName: "",
      phone: "",
      // tel: "",
    };
    (this.itemReqs = [
      {
        billingWeight: "",
        goodsName: "",
        goodsNumber: "",
        grossWeight: "",
        itemCategoryCode: "",
        itemCategoryName: "",
        itemSpecsReqs: [
          {
            height: "",
            length: "",
            packageCout: "",
            wide: "",
          },
        ],
        netWeight: "",
        packageCout: "",
        packageName: "",
        serialNumber: "",
        specs: "",
        volume: "",
        volumeWeight: "",
        weightVolume: "",
        CategoryList: [],
      },
    ]),
      (this.transportPlanReq = {
        carType: "",
        carTypeConfDictId: "",
        takeTime: "",
        transportPlan: "ru_cang:transport_plan",
        // rukuPlanReq: {},
        // waiFaPlanReq: {},
        // zhiSongPlanReq: {},
      });
    this.rukuPlanReq = {
      intoDeptId: "",
      intoDeptName: "",
    };
    this.waiFaPlanReq = {
      carrierDeptId: "",
      carrierDeptName: "",
      carrierId: "",
      carrierName: "",
      outgoingReceiveMethod: "",
      outgoingReceiveMethodConfDictId: "",
      outgoingSendMethod: "",
      outgoingSendMethodConfDictId: "",
    };
    this.zhiSongPlanReq = {
      address: "",
      areaName: "",
      cityName: "",
      company: "",
      contacts: "",
      provinceName: "",
      phone: "",
      // tel: "",
    };
    this.transportPlanReq.takeTime = this.$TOOLS.getCurrentTime();
    this.isSee = "";
    this.disabledSee = false;

    let { commandId, isSee } = this.$route.query || {};
    if (commandId) {
      if (isSee) {
        this.isSee = isSee;
        this.disabledSee = true;
      } else {
        this.saveKeys = 2;
      }
      this.commandId = commandId;
      this.getPackageDetails();
    }
  },
  destroyed() {},
  methods: {
    handleSizeChange_as(val) {
      //  分页
      this.pageTotal_as = val;
      this.getCustomerAddrList();
    },
    handleCurrentChange_as(val) {
      //  分页
      this.pageStart_as = val;
      this.getCustomerAddrList();
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.add(prev, curr);
                  // return this.$TOOLS.mathToFixed(
                  //   this.$TOOLS.add(prev, curr),
                  //   2
                  // );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable1.doLayout();
      });
      return sums;
    },

    //  获取详情
    async getPackageDetails() {
      this.$API
        .runPageReportDetails({
          conditionReqs: [
            {
              conditonKey: "commandId",
              conditonVal: this.commandId,
            },
          ],
          number: "command_detail",
        })
        .then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result.datas[0] || {};
            this.commandReq = {
              //	基础信息
              commandNumber: datas.commandNumber || "",
              customerId: datas.customerId || "",
              customerName: datas.customerName || "",
              customerOrderNumber: datas.customerOrderNumber || "",
              dispatchRecipient: datas.dispatchRecipient || "",
              dispatchRecipientId: datas.dispatchRecipientId || "",
              remarks: datas.remarks || "",
              waybillNumber: datas.waybillNumber || "",
              waybillRecipient: datas.waybillRecipient || "",
              waybillRecipientId: datas.waybillRecipientId || "",
            };
            this.takeAddrReqs = {
              address: datas.startAddrAddress || "",
              areaName: datas.startAddrAreaName || "",
              cityName: datas.startAddrCityName || "",
              company: datas.startAddrCompany || "",
              contacts: datas.startAddrContacts || "",
              provinceName: datas.startAddrProvinceName || "",
              phone: datas.startAddrPhone || "",
              // tel: "",
            };
            this.transportPlanReq = {
              carType: datas.carType || "",
              carTypeConfDictId: datas.carTypeConfDictId || "",
              takeTime: datas.takeTime || "",
              transportPlan: datas.transportPlan || "ru_cang:transport_plan",
              // rukuPlanReq: {},
              // waiFaPlanReq: {},
              // zhiSongPlanReq: {},
            };
            if (datas.storageId) {
              this.remoteMethod(datas.storageName, "storage", "storageList");
            }
            this.rukuPlanReq = {
              intoDeptId: datas.storageId || "",
              intoDeptName: datas.storageName || "",
            };
            if (datas.carrierId) {
              this.focusMethodCarrier("");
              if (datas.carrierDeptId) {
                // 获取承运商——网点
                this.$COMAPI.CarrierDeptList(datas.carrierId).then((res) => {
                  this.CarrierDeptListList = res || [];
                });
              }
            }
            this.waiFaPlanReq = {
              carrierDeptId: datas.carrierDeptId || "",
              carrierDeptName: datas.carrierDeptName || "",
              carrierId: datas.carrierId || "",
              carrierName: datas.carrierName || "",
              outgoingReceiveMethod: datas.receiveMethod || "",
              outgoingReceiveMethodConfDictId:
                datas.receiveMethodConfDictId || "",
              outgoingSendMethod: datas.sendMethod || "",
              outgoingSendMethodConfDictId: datas.sendMethodConfDictId || "",
            };
            this.zhiSongPlanReq = {
              address: datas.taskAddress || "",
              areaName: datas.taskAreaName || "",
              cityName: datas.taskCityName || "",
              company: datas.taskCompany || "",
              contacts: datas.taskContacts || "",
              provinceName: datas.taskProvinceName || "",
              phone: datas.taskPhone || "",
              // tel: "",
            };
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
      this.$API
        .runPageReportDetails({
          conditionReqs: [
            {
              conditonKey: "commandId",
              conditonVal: this.commandId,
            },
          ],
          number: "command_item_list",
        })
        .then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result.datas || [];
            datas.forEach((n, i) => {
              n.CategoryList = [];
              n.serialNumber = "";
              n.specs = "";
              n.operationType = "UNCHANGED";
              this.runPageReportDetailsitemId(n.itemId, i);
            });
            this.itemReqs = datas;
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },
    runPageReportDetailsitemId(conditonVal, i) {
      this.$API
        .runPageReportDetails({
          conditionReqs: [
            {
              conditonKey: "itemId",
              conditonVal,
            },
          ],
          number: "command_item_specs_list",
        })
        .then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result.datas || [];
            datas.forEach((n, i) => {
              n.operationType = "UNCHANGED";
            });
            this.itemReqs[i].itemSpecsReqs = datas;
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },

    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod("", key, keys);
      }
    },
    //员工、部门、外发网点
    changeMethod(e, arrs, keys) {
      let curs = this[arrs].filter((item) => item.documentId == e);
      if (keys == "intoDeptName") {
        this.rukuPlanReq[keys] = (curs.length && curs[0].name) || "";
      } else {
        this.commandReq[keys] = (curs.length && curs[0].name) || "";
      }
    },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          this[keys] = arrs;
          console.log(this[keys]);
        });
    },

    //外发承运商
    focusMethodCarrier() {
      if (this.changeCarrierList.length == 0) {
        this.remoteMethodCarrier("");
      }
    },
    //外发承运商
    changeMethodCarrier(e) {
      let curs = this.changeCarrierList.filter((item) => item.carrierId == e);
      this.waiFaPlanReq.carrierName =
        (curs.length && curs[0].carrierName) || "";
      if (e) {
        // 获取承运商——网点
        this.$COMAPI.CarrierDeptList(e).then((res) => {
          this.CarrierDeptListList = res || [];
        });
      }
    },
    //外发承运商 carrierId carrierName
    remoteMethodCarrier(carrierName) {
      this.$API
        .CarrierList({
          carrierName,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.changeCarrierList = res.data.result.data || [];
        });
    },

    //品类
    focusMethodCategory(index) {
      if (this.itemReqs[index].CategoryList.length == 0) {
        this.remoteMethodCategory("", index);
      }
    },
    //品类
    changeMethodCategory(e, index) {
      this.itemReqs[index].operationType = "UPDATE";
      let curs = this.itemReqs[index].CategoryList.filter(
        (item) => item.itemCategoryName == e
      );
      this.itemReqs[index].itemCategoryCode =
        (curs.length && curs[0].itemCategoryCode) || "";
      console.log(this.itemReqs[index].itemCategoryCode);
    },
    //品类
    remoteMethodCategory(categoryName, index) {
      this.$API
        .wtl_getCategoryList({
          categoryName,
          pageStart: 1,
          pageTotal: 20,
        })
        .then((res) => {
          this.itemReqs[index].CategoryList = res.data.result.data || [];
        });
    },

    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "package_name") {
            // 包装
            this.packageNameList = arrs;
          }
          if (dictType == "car_type") {
            // 车型
            this.car_type_list = arrs;
          }
          if (dictType == "out_going_take_method") {
            // 外发提货
            this.OUTTakeMethodList = arrs;
          }
          if (dictType == "out_going_send_method") {
            // 外发送货方式
            this.OUTsendMethodList = arrs;
          }
        });
    },

    //货物信息 添加一行货物信息
    AddGoods(idx) {
      let objs = {
        billingWeight: "",
        goodsName: "",
        goodsNumber: "",
        grossWeight: "",
        itemCategoryCode: "",
        itemCategoryName: "",
        itemSpecsReqs: [
          {
            height: "",
            length: "",
            packageCout: "",
            wide: "",
          },
        ],
        netWeight: "",
        packageCout: "",
        packageName: "",
        serialNumber: "",
        specs: "",
        volume: "",
        volumeWeight: "",
        weightVolume: "",
        CategoryList: [],
      };
      if (this.saveKeys == 2 && this.commandId) {
        objs.operationType = "ADD";
      }
      this.itemReqs.push(objs);
    },
    //货物信息 删除一行货物信息
    delGoods(idx) {
      this.itemReqs.splice(idx, 1);
    },
    onInputHW(index) {
      this.itemReqs[index].operationType = "UPDATE";
    },
    //设置规格
    clickSet(index) {
      this.specIndex1 = index;
      this.itemReqs[index].operationType = "UPDATE";
      this.specifications = this.itemReqs[index].itemSpecsReqs;
      this.isShowDialog1 = true;
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
    },
    //设置规格  确认保存
    diaConfirmBtn1() {
      this.itemReqs[this.specIndex1].itemSpecsReqs = this.specifications;
      this.isShowDialog1 = false;
    },

    //设置规格 添加规格
    clickAdd() {
      this.specifications.push({
        height: "",
        length: "",
        packageCout: "",
        wide: "",
        operationType: "ADD",
      });
    },
    //设置规格 删除一行规格
    clickDel(index) {
      this.specifications.splice(index, 1);
    },
    onInput(index) {
      this.specifications[index].operationType = "UPDATE";
    },

    //客户
    remoteMethodCustomer(customerName) {
      this.$API
        .CustomerList({
          customerName,
          pageStart: 1,
          pageTotal: 20,
          approveStatus: "tong_guo:approve_status",
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    //客户
    focusMethodCustomer() {
      if (this.CustomerLists.length == 0) {
        this.remoteMethodCustomer("");
      }
    },
    //客户  选择或者清除客户时触发
    changeMethodCustomer(e) {
      let curs = this.CustomerLists.filter((item) => item.customerName == e);
      let customerId = (curs.length && curs[0].customerId) || "";
      this.commandReq.customerId = customerId;
      if (customerId) {
        this.getCustomerDefaultAddrList(customerId);
      }
    },
    //客户 根据客户id获取客户默认地址
    getCustomerDefaultAddrList(id) {
      this.$API
        .wtl_getCustomerDefaultAddrList({ customerId: id })
        .then((res) => {
          let datas = res.data.result || [];
          if (datas.length > 0) {
            let jjAddressData = {}; // 寄件默认地址;
            let sjAddressData = {}; // 收件默认地址;
            datas.forEach((item) => {
              if (item.addressType == "ji_jian:address_type") {
                jjAddressData = item;
              }
              if (item.addressType == "shou_jian:address_type") {
                sjAddressData = item;
              }
            });
            if (jjAddressData) {
              jjAddressData.contacts = jjAddressData.personnelName;
              jjAddressData.company = jjAddressData.deptName;
              this.takeAddrReqs = JSON.parse(JSON.stringify(jjAddressData));
            }
            if (sjAddressData) {
              sjAddressData.contacts = sjAddressData.personnelName || "";
              sjAddressData.company = sjAddressData.deptName || "";
              this.zhiSongPlanReq = JSON.parse(JSON.stringify(sjAddressData));
            }
          }
        });
    },

    // 发货地址 自动识别地址
    geocode(getAddress, getcity) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: getcity || "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let sj = JSON.parse(JSON.stringify(this.takeAddrReqs));
        sj.provinceName = datas.province;
        sj.cityName = datas.city;
        sj.areaName = datas.district;
        this.takeAddrReqs = sj;
      });
    },
    // 收货地址 自动识别地址
    geocode_1(getAddress, getcity) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: getcity || "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let sj = JSON.parse(JSON.stringify(this.zhiSongPlanReq));
        sj.provinceName = datas.province;
        sj.cityName = datas.city;
        sj.areaName = datas.district;
        this.zhiSongPlanReq = sj;
      });
    },
    // 默认查省级
    getParentName(e) {
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.SuperiorRegionList = res.data.result.data || [];
        });
    },
    // 获取市 (收货地址)
    getCityName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityNameList = res.data.result.data || [];
        });
    },
    // 获取市 (收货地址)
    getAreaName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.areaNameList = res.data.result.data || [];
        });
    },
    // 选择省(收货地址)
    changeProvince(e) {
      this.takeAddrReqs.cityName = "";
      this.takeAddrReqs.areaName = "";
      this.cityNameList = [];
      this.areaNameList = [];
      if (e) {
        this.getCityName(e);
      }
    },
    // 选择市(收货)
    changeCity(e) {
      this.takeAddrReqs.areaName = "";
      this.areaNameList = [];
      if (e) {
        this.getAreaName(e);
      }
    },
    // 获取市 (收货地址)
    getCityName_1(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityNameList_1 = res.data.result.data || [];
        });
    },
    // 获取市 (收货地址)
    getAreaName_1(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.areaNameList_1 = res.data.result.data || [];
        });
    },
    // 选择省(收货地址)
    changeProvince_1(e) {
      this.zhiSongPlanReq.cityName = "";
      this.zhiSongPlanReq.areaName = "";
      this.cityNameList_1 = [];
      this.areaNameList_1 = [];
      if (e) {
        this.getCityName_1(e);
      }
    },
    // 选择市(收货)
    changeCity_1(e) {
      this.zhiSongPlanReq.areaName = "";
      this.areaNameList_1 = [];
      if (e) {
        this.getAreaName_1(e);
      }
    },

    //收发货地址
    handleCloseDia3() {
      this.isShowDialog3 = false;
      this.queryData = {
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      };
    },
    //收发货地址  弹窗确认保存事件
    diaConfirmBtn3() {
      // 添加费项
      this.isShowDialog3 = false;
    },
    //收发货地址  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn3() {
      this.isShowDialog3 = false;
    },
    //收发货地址 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    //收发货地址 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //收发货地址 选择收件人地址
    changeRecAddress(type) {
      if (type == 1) {
        this.dialogTitle3 = "选择发货地址";
        this.queryData.addressType = "ji_jian:address_type";
      } else {
        this.dialogTitle3 = "选择收货地址";
        this.queryData.addressType = "shou_jian:address_type";
      }
      this.queryData.customerId = this.commandReq.customerId || "";
      if (this.commandReq.customerId) {
        this.isShowDialog3 = true;
        this.getCustomerListAddress();
        this.getCustomerAddrList();
      } else {
        if (this.commandReq.customerName) {
          this.$message.warning("当前客户没有客户档案").showClose = true;
        } else {
          this.$message.warning("请先选择客户").showClose = true;
        }

        return false;
      }
    },
    //收发货地址 选择地址
    changeAddress(row) {
      if (this.queryData.addressType == "ji_jian:address_type") {
        //寄件
        this.takeAddrReqs.company = row.deptName || "";
        this.takeAddrReqs.contacts = row.personnelName || "";
        this.takeAddrReqs.phone = row.tel || "";
        this.takeAddrReqs.provinceName = row.provinceName || "";
        this.takeAddrReqs.cityName = row.cityName || "";
        this.takeAddrReqs.areaName = row.areaName || "";
        this.takeAddrReqs.address = row.address || "";
        this.isShowDialog3 = false;
        this.getCityName(row.provinceName);
        this.getAreaName(row.cityName);
      } else {
        //收件
        this.zhiSongPlanReq.company = row.deptName || "";
        this.zhiSongPlanReq.contacts = row.personnelName || "";
        this.zhiSongPlanReq.phone = row.tel || "";
        this.zhiSongPlanReq.provinceName = row.provinceName || "";
        this.zhiSongPlanReq.cityName = row.cityName || "";
        this.zhiSongPlanReq.areaName = row.areaName || "";
        this.zhiSongPlanReq.address = row.address || "";
        this.isShowDialog3 = false;
        this.getCityName_1(row.provinceName);
        this.getAreaName_1(row.cityName);
      }
    },
    //收发货地址 获取客户档案列表()
    getCustomerListAddress(name) {
      this.$API
        .wtl_getCustomerList({
          customerName: name || "",
          approveStatus: "tong_guo:approve_status", //审核通过
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.addressNaemList = res.data.result.data || [];
        });
    },
    //收发货地址 收-发货人列表
    getCustomerAddrList() {
      this.$API
        .wtl_getCustomerAddrList({
          customerId: this.queryData.customerId,
          addressType: this.queryData.addressType,
          deptName: this.queryData.deptName,
          personnelName: this.queryData.personnelName,
        })
        .then((res) => {
          this.tableData = res.data.result.data || [];
          this.pageCount_as = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            let Heigth = this.$refs.myDialogRef_as.offsetHeight || 0; //弹窗的高度
            this.TBHeight_as = Heigth * 1 - 51 - 54 - 40;
          });
        });
    },

    // 收录客户地址
    autoAddCustomerAddrApi(datas) {
      return this.$API
        .autoAddCustomerAddr({
          address: datas.address || "",
          addressType: datas.addressType || "",
          cityName: datas.cityName || "",
          contacts: datas.contacts || "",
          customerId: datas.customerId || "",
          provinceName: datas.provinceName || "",
          tel: datas.tel || "",
          addressName: datas.addressName || "",
          areaName: datas.areaName || "",
          phone: datas.phone || "",
          remarks: datas.remarks || "",
          deptName: datas.deptName || "",
        })
        .then((res) => {});
    },
    saveClick(key) {
      //新增
      this.saveKeys = key;
      this.disabledSee = false;
      // switch (key) {
      //   case 1:

      //     break;
      //   case 2:
      //     break;
      //   case 3:
      //     break;
      // }
    },
    // 提交
    async submit() {
      //提货信息 车型
      let curs1 = this.car_type_list.filter(
        (item) => item.confDictId == this.transportPlanReq.carTypeConfDictId
      );
      this.transportPlanReq.carType = (curs1.length && curs1[0].val) || "";

      //外发 提货方式 名称
      let curs2 = this.OUTTakeMethodList.filter(
        (item) =>
          item.confDictId == this.waiFaPlanReq.outgoingReceiveMethodConfDictId
      );
      this.waiFaPlanReq.outgoingReceiveMethod =
        (curs2.length && curs2[0].val) || "";

      //外发 送货方式 名称
      let curs3 = this.OUTsendMethodList.filter(
        (item) =>
          item.confDictId == this.waiFaPlanReq.outgoingSendMethodConfDictId
      );
      this.waiFaPlanReq.outgoingSendMethod =
        (curs3.length && curs3[0].val) || "";

      //外发 承运商网点名称
      let curs4 = this.CarrierDeptListList.filter(
        (item) => item.carrierDeptId == this.waiFaPlanReq.carrierDeptId
      );
      this.waiFaPlanReq.carrierDeptName =
        (curs4.length && curs4[0].deptName) || "";

      let itemReqs = _.cloneDeep(this.itemReqs);
      itemReqs.forEach((element) => {
        delete element.CategoryList;
      });
      let params = {
        commandReq: this.commandReq,
        takeAddrReqs: [
          {
            ...this.takeAddrReqs,
            itemReqs,
          },
        ],
      };

      if (this.saveKeys == 2 && this.commandId) {
        params.transportPlanReq = {
          ...this.transportPlanReq,
        };
        switch (this.transportPlanReq.transportPlan) {
          case "ru_cang:transport_plan":
            params.transportPlanReq.rukuPlanReq = this.rukuPlanReq;
            break;
          case "zhi_song:transport_plan":
            params.transportPlanReq.zhiSongPlanReq = this.zhiSongPlanReq;
            break;
          case "wai_fa:transport_plan":
            params.transportPlanReq.waiFaPlanReq = this.waiFaPlanReq;
            break;
        }

        params.commandReq.commandId = this.commandId;
        this.$API.commandupdateCommand(params).then((res) => {
          this.$message.success(res.data.message || "修改成功");
          this.$TOOLS.closePage();
          this.$router.push({
            path: "/WaybillManage/NewPickupInstructionList",
            query: {
              isreload: "isreload",
            },
          });
        });
      } else {
        params.transportPlanReq = {
          ...this.transportPlanReq,
        };
        switch (this.transportPlanReq.transportPlan) {
          case "ru_cang:transport_plan":
            params.transportPlanReq.rukuPlanReq = this.rukuPlanReq;
            break;
          case "zhi_song:transport_plan":
            params.transportPlanReq.zhiSongPlanReq = this.zhiSongPlanReq;
            break;
          case "wai_fa:transport_plan":
            params.transportPlanReq.waiFaPlanReq = this.waiFaPlanReq;
            break;
        }
        const this_ = this;
        await this.$API.commandaddCommand(params).then((res) => {
          if (this_.commandReq.customerId) {
            if (this_.isAutoAddr_sj) {
              // 自动收录收件地址
              this_.autoAddCustomerAddrApi({
                customerId: this_.commandReq.customerId || "",
                addressType: "ji_jian:address_type",
                address: this_.takeAddrReqs.address || "",
                cityName: this_.takeAddrReqs.cityName || "",
                contacts: this_.takeAddrReqs.contacts || "",
                provinceName: this_.takeAddrReqs.provinceName || "",
                tel: this_.takeAddrReqs.phone || "",
                addressName: "", //地址简称
                areaName: this_.takeAddrReqs.areaName || "",
                phone: this_.takeAddrReqs.phone || "",
                deptName: this_.takeAddrReqs.company || "",
                remarks: "",
              });
            }
            if (
              this_.isAutoAddr_sj_1 &&
              this.transportPlanReq.transportPlan == "zhi_song:transport_plan"
            ) {
              // 自动收录收件地址
              this_.autoAddCustomerAddrApi({
                customerId: this_.commandReq.customerId || "",
                addressType: "shou_jian:address_type",
                address: this_.zhiSongPlanReq.address || "",
                cityName: this_.zhiSongPlanReq.cityName || "",
                contacts: this_.zhiSongPlanReq.contacts || "",
                provinceName: this_.zhiSongPlanReq.provinceName || "",
                tel: this_.zhiSongPlanReq.phone || "",
                addressName: "", //地址简称
                areaName: this_.zhiSongPlanReq.areaName || "",
                phone: this_.zhiSongPlanReq.phone || "",
                deptName: this_.zhiSongPlanReq.company || "",
                remarks: "",
              });
            }
          }
          this.$confirm("新建成功 ", "提示：", {
            confirmButtonText: "查看列表",
            cancelButtonText: "继续新建",
          })
            .then(() => {
              this_.$message.success(res.data.message || "新增成功");
              this.$TOOLS.closePage();
              this.$router.push({
                path: "/WaybillManage/NewPickupInstructionList",
                query: {
                  isreload: "isreload",
                },
              });
            })
            .catch(() => {});
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;

.topBtns {
  width: calc(100% - 240px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}

.infoDiv {
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .formbox {
    padding: 0 30px;

    .jsInput {
      .jsBtns {
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        border: none;
      }
    }
  }

  .goodsItmes {
    margin-top: 30px;
    border-bottom: 4px solid #ccc;
    padding-bottom: 20px;
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .miniInput {
    width: 80px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-right: 2px;

    text-align: center;

    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0 5px;
    }
  }
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectAddress {
  border: 1px solid #ccc;
  margin-right: 10px;
  width: 180px !important;
}
.addressDetails {
  //   width: 380px !important;
  flex: 1;
}

.btmBtns {
  text-align: center;
  margin-top: 50px;

  .saveBtns {
    font-size: 16px;
  }
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
    cursor: pointer;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.addTiHuoDiZhi {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}

.textArea {
  height: 100%;
}

.glo_btnItems {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}

.goodsTable {
  /deep/ .el-table .cell {
    padding-right: 0;
    padding-left: 0;
  }
}

// #tables {
//   .glo_formBox {
//     /deep/ .el-input__icon {
//       line-height: 30px !important;
//     }
//   }
// }
.linkTabel {
  text-align: center;
  cursor: pointer;
}
/deep/ .el-input__icon {
  line-height: 30px !important;
}

.disFlex {
  display: flex;
  align-items: center;
}

.checkBox {
  margin-left: 30px;
}

#tiHuoForm {
  padding: 10px;
  border: 1px dashed @borderColor;
  margin: 0 45px 10px 30px;
}
</style>
